import { Controller } from "@hotwired/stimulus";
import "videojs-contrib-quality-levels";
import "videojs-event-tracking";
import videojs from "video.js";

import ahoy from "ahoy.js";

export default class extends Controller {
  static targets = ["player"];
  static values = {
    hideControls: { type: Boolean, default: false },
    id: String,
    source: String,
    poster: String,
  };

  connect() {
    window.VIDEOJS_NO_DYNAMIC_STYLE = true;
    let playerSrc = `<video data-video-target="player">
    <source src="${this.sourceValue}" type="application/x-mpegURL" poster="${this.posterValue}">
  </video>`;
    this.element.innerHTML = playerSrc;

    let options = { eventTracking: true };
    if (this.hideControlsValue) {
      options["controls"] = false;
    } else {
      options["controls"] = true;
      options["autoplay"] = false;
      options["fluid"] = true;
    }
    let videoPlayer = videojs(this.playerTarget, options);
    videoPlayer.addClass("video-js");
    videoPlayer.addClass("vjs-big-play-centered");
    console.log(this.idValue);
    if (this.idValue) {
      videoPlayer.eventTracking({ videoId: this.idValue });

      videoPlayer.on("tracking:play", (e, data) => {
        console.log(e);
        data["videoId"] = this.idValue;
        ahoy.track("play", data);
      });
      videoPlayer.on("tracking:firstplay", (e, data) => {
        console.log(e);
        data["videoId"] = this.idValue;
        ahoy.track("firstplay", data);
      });
      videoPlayer.on("tracking:pause", (e, data) => {
        console.log(e);
        data["videoId"] = this.idValue;
        ahoy.track("tracking:pause", data);
      });
      videoPlayer.on("tracking:seek", (e, data) => {
        console.log(e);
        data["videoId"] = this.idValue;
        ahoy.track("tracking:seek", data);
      });
      videoPlayer.on("tracking:buffered", (e, data) => {
        console.log(e);
        data["videoId"] = this.idValue;
        ahoy.track("tracking:buffered", data);
      });
      videoPlayer.on("tracking:first-quarter", (e, data) => {
        console.log(e);
        data["videoId"] = this.idValue;
        ahoy.track("tracking:first-quarter", data);
      });
      videoPlayer.on("tracking:second-quarter", (e, data) => {
        console.log(e);
        data["videoId"] = this.idValue;
        ahoy.track("tracking:second-quarter", data);
      });
      videoPlayer.on("tracking:third-quarter", (e, data) => {
        console.log(e);
        data["videoId"] = this.idValue;
        ahoy.track("tracking:third-quarter", data);
      });
      videoPlayer.on("tracking:fourth-quarter", (e, data) => {
        console.log(e);
        data["videoId"] = this.idValue;
        ahoy.track("tracking:fourth-quarter", data);
      });
    }
  }
  disconnect() {}
}
